var map = {
	"./c1.png": "bfb5",
	"./c10.png": "e7f4",
	"./c11.png": "1a72",
	"./c12.png": "686b",
	"./c13.png": "2554f",
	"./c2.png": "0d0f",
	"./c3.png": "8b35",
	"./c4.png": "16a6",
	"./c5.png": "33fc",
	"./c6.png": "20c1",
	"./c7.png": "976f",
	"./c8.png": "bf8c",
	"./c9.png": "54ad",
	"./d1.png": "2b87",
	"./d10.png": "3cd7",
	"./d11.png": "9453",
	"./d12.png": "15a5",
	"./d13.png": "5177",
	"./d2.png": "c915",
	"./d3.png": "68fe",
	"./d4.png": "806d",
	"./d5.png": "74c0",
	"./d6.png": "610a",
	"./d7.png": "8417",
	"./d8.png": "e3f7",
	"./d9.png": "a752",
	"./e.png": "59f8",
	"./h1.png": "6289",
	"./h10.png": "4c54",
	"./h11.png": "4567",
	"./h12.png": "3a51",
	"./h13.png": "6f2c",
	"./h2.png": "6988",
	"./h3.png": "a2b1",
	"./h4.png": "cb44",
	"./h5.png": "0502",
	"./h6.png": "695b",
	"./h7.png": "8703",
	"./h8.png": "f87e",
	"./h9.png": "0f09",
	"./j1.png": "a447",
	"./j2.png": "8958",
	"./j3.png": "c7f3",
	"./s1.png": "9dc6",
	"./s10.png": "b57b",
	"./s11.png": "8bcd",
	"./s12.png": "3e8b",
	"./s13.png": "86c9",
	"./s2.png": "2771",
	"./s3.png": "e7a6",
	"./s4.png": "7fbe",
	"./s5.png": "7f5b",
	"./s6.png": "89254",
	"./s7.png": "3023",
	"./s8.png": "dfb7",
	"./s9.png": "443c",
	"./suit-c-m.png": "2c4e",
	"./suit-c-s.png": "6664",
	"./suit-d-m.png": "2449",
	"./suit-d-s.png": "f890",
	"./suit-h-m.png": "fd7a",
	"./suit-h-s.png": "9c22",
	"./suit-s-m.png": "9853",
	"./suit-s-s.png": "a6a9",
	"./w.png": "61a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f98f";